import { Box, useTexture } from "@react-three/drei";
import { SpotLight } from "@react-three/drei";
import { useEffect, useRef } from "react";
import RainyTheme from "./RainyTheme";
import { THEMES } from "./constants/themes.js";
import { useSelector } from "react-redux";
import GroundCircle from "./GroundCircle.jsx";

const Themes = ({ theme, radius }) => {
  const spotLight = useRef();
  const cube = useRef();
  const spriteRef = useRef();

  const themeTexture = useTexture(THEMES[theme]);

  const areThemesHidden = useSelector(
    (state) => state.configurator?.areThemesHidden
  );

  // Allows the spotlight to fix the hidden <Box> under it
  useEffect(() => {
    if (theme === "blackAndWhite" || theme === "sepia")
      spotLight.current.target = cube.current;
  }, []);

  return (
    <>
      {theme === "blackAndWhite" || theme === "sepia" ? (
        <group visible={areThemesHidden}>
          {/* This mesh is here to give a target to the light, otherwise the light aims at world center */}
          <Box
            ref={cube}
            args={[0, 0, 0]}
            position={[0, 0, 0]}
            visible={false}
          />
          <sprite ref={spriteRef} position={[0, 4.5, 0]}>
            <spriteMaterial attach="material" map={themeTexture} />
          </sprite>
          <SpotLight
            ref={spotLight}
            position-y={4}
            distance={3.94}
            attenuation={6}
            anglePower={2}
            radiusTop={0.03}
            radiusBottom={radius / 2}
            opacity={1.1}
            color={theme === "blackAndWhite" ? "#585959" : "#9E5B40"}
          />
          {/* This component represents the area of effect on the ground */}
          <GroundCircle position={[0, 0.02, 0]} radius={radius / 2} />
        </group>
      ) : (
        <group position={[0, 3, 0]} visible={areThemesHidden}>
          <sprite ref={spriteRef} position={[0, 1.5, 0]}>
            <spriteMaterial attach="material" map={themeTexture} />
          </sprite>
          <RainyTheme radius={radius} />
          <GroundCircle position={[0, -2.98, 0]} radius={radius / 2} />
        </group>
      )}
    </>
  );
};

export default Themes;
